// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parentNode {
    cursor: default;
}

.childNode {
    cursor: pointer;
}

.dimTabGroup {
    min-height: 400px;
}

    .dimTabGroup .min-width {
        width: 250px;
    }

::ng-deep .dimTabGroup input.mat-chip-input {
    flex: 1 0 auto !important;
}

::ng-deep .dimTabGroup .mat-tab-body-content {
    overflow: hidden;
}

.attrStack {
    overflow-y: auto;
}

.attrStack > * {
    flex-shrink: 0;
}

.attrTable {
    margin-right: 5px;
    flex: 1 1;
}

.hierListBox {
    margin-right: 5px;
}

.hierStack {
    overflow-y: auto;
    overflow-x: hidden;
}

.attrChip {
    width: 99%!important;
}

.relStack > * {
    align-self: center;
}

.relStack > .attrField {
    width: 250px;
}

.relStack > .attrIcon {
    margin: 0px 7px;
}

.hierTabContent {
    padding-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/containerdimension/containerdimension.settings.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;IAEI;QACI,YAAY;IAChB;;AAEJ;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".parentNode {\n    cursor: default;\n}\n\n.childNode {\n    cursor: pointer;\n}\n\n.dimTabGroup {\n    min-height: 400px;\n}\n\n    .dimTabGroup .min-width {\n        width: 250px;\n    }\n\n::ng-deep .dimTabGroup input.mat-chip-input {\n    flex: 1 0 auto !important;\n}\n\n::ng-deep .dimTabGroup .mat-tab-body-content {\n    overflow: hidden;\n}\n\n.attrStack {\n    overflow-y: auto;\n}\n\n.attrStack > * {\n    flex-shrink: 0;\n}\n\n.attrTable {\n    margin-right: 5px;\n    flex: 1 1;\n}\n\n.hierListBox {\n    margin-right: 5px;\n}\n\n.hierStack {\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.attrChip {\n    width: 99%!important;\n}\n\n.relStack > * {\n    align-self: center;\n}\n\n.relStack > .attrField {\n    width: 250px;\n}\n\n.relStack > .attrIcon {\n    margin: 0px 7px;\n}\n\n.hierTabContent {\n    padding-top: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
